import React, { useEffect, useMemo, useState } from 'react';
import style from './navigation.module.sass';
import { ReactComponent as Dashboard } from '../../assets/svg/sidemenu/dashboard.svg';
import { ReactComponent as Apps } from '../../assets/svg/sidemenu/apps.svg';
import { ReactComponent as Environment } from '../../assets/svg/sidemenu/environment.svg';
import { ReactComponent as Admin } from '../../assets/svg/sidemenu/admin.svg';
import { ReactComponent as ThemeManager } from '../../assets/svg/sidemenu/themeManager.svg';
// import { ReactComponent as Logo } from '../../assets/svg/sidemenu/a8_logo_white.svg';
import { ReactComponent as UniphoreLogo } from '../../assets/svg/sidemenu/uniphore_logo.svg';
import { ReactComponent as Help } from '../../assets/svg/sidemenu/help.svg';
import { ReactComponent as MarketplaceIcon } from '../../assets/svg/sidemenu/marketplace.svg';
import { ReactComponent as DownloadIcon } from '../../assets/svg/sidemenu/download.svg';
import { ReactComponent as Settings } from '../../assets/svg/modalSettingsIcon.svg';
import { ReactComponent as Logout } from '../../assets/svg/logout.svg';
import { ReactComponent as UserImage } from '../../assets/svg/sidemenu/userProfile.svg';
import { ReactComponent as Home } from '../../assets/svg/sidemenu/homeSvg.svg';
// import UserImage from '../../assets/images/sampleUserImage.png';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { Popover, Tooltip } from 'antd'
import Onboarding from '../apps/forms/formBuilder/components/onboarding';
import { AppState } from '../../stateManager/store';
import { setGuideVisible, setInitialOnboarding, setStepIndex } from '../../stateManager/store/onboarding/action';
import { getOnboarding } from '../../helpers/onboardingHelper';
import { motion } from 'framer-motion';

const SidenavBar: React.FC = () => {
    let location = useLocation().pathname.split('/')[1];
    let locationSplit = useLocation().pathname.split('/');
    const { capabilities } = useSelector((state: AppState) => state.user.userDetails)
    const items = capabilities?.length ? capabilities : ['Home', 'Apps', `Environment`, `Theme Manager`, `Admin`, `Marketplace`, `Downloads`];
    const getLocationIndex = () => {
        const segment = locationSplit[3]?.toLowerCase();
        return items.findIndex((item: string) => {
            const lowerItem = item.toLowerCase();
            if (location.includes(lowerItem)) return true;

            if (location.startsWith('organization')) {
                if (segment === 'env' && lowerItem.includes('environment')) return true;
                if (segment === 'thememanager' && lowerItem.includes('theme manager')) return true;
                if (['teams', 'users', 'policy', 'audit', 'downloads'].includes(segment) && lowerItem === 'admin') return true;
            }

            return false;
        });
    };

    const [selected, setSelected] = useState<any>(getLocationIndex());
    let history = useHistory();
    const dispatch = useDispatch()
    const onRedirect = (path: string) => {
        history.push("/" + path);
    }
    const [popUpState, setPopUpState] = useState<boolean>(false)
    const currentOrgId = useSelector((state: any) => {
        return state.org.selectedOrg.id
    })
    const { guideVisible,  info: onboardingInfo, loading, steps } = useSelector((state: AppState)=> state.onboarding)
    const userDetails = useSelector((state: any) => {
        return state.user.userDetails
    })
    const user = useSelector((state: AppState) => state.user.data.user)
    const {isExistServiceTask} = onboardingInfo;

    useEffect(()=>{
        const fetchOnboarding = async () => {
           try {
            const data = await getOnboarding(user.userName)
            if (data) {
                dispatch(setInitialOnboarding(data))
            }
           } catch (err) {
            console.error("Fetching onboarding error", err)
           }
        }
        fetchOnboarding()  
    },[])

    const popupTitle = (
        <div className={style.popupTitle}>
            <Tooltip placement='right'
                title={
                    (userDetails && userDetails?.firstName && userDetails?.lastName) ? (userDetails.firstName + " " + userDetails?.lastName) :
                    (userDetails && userDetails.firstName) ? (userDetails.firstName) : userDetails?.userName ? userDetails.userName : 'User'
                }
            >
                {(userDetails && userDetails?.firstName && userDetails?.lastName) ? (userDetails.firstName + " " + userDetails?.lastName) :
                    (userDetails && userDetails.firstName) ? (userDetails.firstName) : userDetails?.userName ? userDetails.userName : 'User'}
            </Tooltip>
        </div>
    )
    const popupContent = (
        <div className={style.popupContent}>
            <div data-test-id="profile" className={style.item} onClick={() => {
                setPopUpState(false)
                history.push("/profile")
            }}>
                <Settings height='14px' width='14px'></Settings>
                <span className={style.itemText}>Preference</span>
            </div>
            <div data-test-id="sign_in" className={style.item} onClick={() => {
                setPopUpState(false)
                // Clears entire redux store
                dispatch({
                    type: 'LOG_OUT'
                })
                localStorage.clear();
                history.push('/signin');
            }}>
                <Logout data-test-id="logout" height='14px' width='14px'></Logout>
                <span className={style.itemText}>Logout</span>
            </div>
        </div>
    )

    const handleTour = (path?: string) => {
        const { guideCompleted, skipTour, level } = onboardingInfo;
        if (guideCompleted === false && !skipTour && level) {
            let ms = 0;
            const { stageIndex} = onboardingInfo;
            const { appId, appType, flowId, formId, isV2, serviceId, bpmnCheckout } = onboardingInfo;
            let type = appType === "a8solo" ? "solo" : "assist"
            let v2 = isV2 ? "v2" : "";
            
            if (stageIndex === 0) {
                history.push("/apps/list")
            } else if (stageIndex === 1 && appId) {
                if (bpmnCheckout) {
                    history.push(`/apps/list/${appId}/journey/${type}/list/${flowId}/create`)   
                } else {
                    history.push(`/apps/list/${appId}/journey/${type}/list`)    
                }
            } else if (stageIndex === 2 && appId) {
                history.push(`/apps/list/${appId}/${type}/forms/list`)
            } else if (stageIndex === 3 && appId && isExistServiceTask) {    
                dispatch(setStepIndex(0))
                history.push(`/apps/list/${appId}/assist/service/list`)
            } else if ((stageIndex === 4 && appId) || (appId && !isExistServiceTask)) {
                history.push(`/apps/list/${appId}/assist/deploy/list`)
            }
            setTimeout(() => {
                dispatch(setGuideVisible(true))
            }, ms)
        } else if (path){
            onRedirect(path)
        }
    }

    useEffect(()=>{
        const backgroundDiv = document.getElementById("background-div");
        const idx = getLocationIndex()
        if (backgroundDiv) {
            if (idx == -1) {
                backgroundDiv.style.display = "none";
            }
            else {
                backgroundDiv.style.display = "flex";
            }
        }
        setSelected(idx)
        const {guideCompleted} = onboardingInfo;
        if (guideCompleted === false && location === "apps" && !loading) {
            handleTour()
        } else {
            dispatch(setGuideVisible(false))
        }
    },[loading, location])


    const handleRedirect = (key: string) => {
        const backgroundDiv = document.getElementById("background-div");
        if (backgroundDiv) {
          backgroundDiv.style.display = "flex";
        }
        switch (key) {
            case 'Home':
                onRedirect('home');
                break;
            case 'Apps':
                handleTour('apps/list');
                break;
            case 'Environment':
                currentOrgId
                    ? onRedirect(`organization/${currentOrgId}/env`)
                    : onRedirect('organization');
                break;
            case 'Theme Manager':
                currentOrgId
                    ? onRedirect(`organization/${currentOrgId}/themeManager`)
                    : onRedirect('organization');
                break;
            case 'Admin':
                currentOrgId
                    ? onRedirect(`organization/${currentOrgId}/teams`)
                    : onRedirect('organization');
                break;
            case 'Marketplace':
                onRedirect('marketplace');
                break;
            case 'Downloads':
                onRedirect('downloads');
                break;
            default:
                break;
        }
    };
    
    const icons = useMemo(() => [
        {
            key: 'Home',
            icon: <Home style={{ color: (location === 'home' && selected !== -1) ? '#FFFFFF' : 'inherit' }} />
        },
        {
            key: 'Apps',
            icon: <Apps style={{ color: (location === 'apps' && selected !== -1) ? '#FFFFFF' : 'inherit' }} />
        },
        {
            key: 'Environment',
            icon: (
                <Environment
                    style={{ color: ((location === 'organization' && selected !== -1) && locationSplit[3] === 'env') ? '#FFFFFF' : 'inherit' }}
                />
            )
        },
        {
            key: 'Theme Manager',
            icon: (
                <ThemeManager
                    style={{
                        color:
                            (location === 'organization' &&
                                selected !== -1 &&
                                locationSplit[3] === 'themeManager')
                                ? '#FFFFFF'
                                : 'inherit'
                    }}
                />
            )
        },
        {
            key: 'Admin',
            icon: (
                <Admin
                    style={{
                        color:
                            (location === 'organization' &&
                                selected !== -1 &&
                                ['teams', 'users', 'policy', 'audit', 'downloads'].includes(locationSplit[3]))
                                ? '#FFFFFF'
                                : 'inherit'
                    }}
                />
            )
        },
        {
            key: 'Marketplace',
            icon: <MarketplaceIcon style={{ color: (location === 'marketplace' && selected !== -1) ? '#FFFFFF' : 'inherit' }} />
        },
        {
            key: 'Downloads',
            icon: <DownloadIcon style={{ color: (location === 'downloads' && selected !== -1) ? '#FFFFFF' : 'inherit' }} />
        }
    ], [location, locationSplit, selected]);

    return (
        <div className={style.sideNav} style={{ position: "relative" }}>            
            <ul className={style.itemContainer} style={{ display: 'flex', flexDirection: 'column', gap: '0px', listStyle: 'none', padding: 0,width:44,justifyContent:'center' }}>
                <motion.div
                   id='background-div'
                    layout
                    initial={false}
                    animate={{ y: selected * 52 }}
                    transition={{
                        type: "spring",
                        stiffness: 300,
                        damping: 20,
                    }}
                    style={{
                        position: "absolute",
                        display: "flex",
                        alignItems: "center",
                        width: 44,
                        height: 44,
                        justifyContent: "center",
                        top: 72,
                        backgroundColor: "#15808C",
                        borderRadius: "10px",
                        boxShadow: "0px 6px 10px 0px #15808C3D",
                    }}
                />
                <li className={style.logo} style={{height:72}}>
                    <UniphoreLogo />
                </li>
                {items.map((item: any, index: number) => (
                    <Tooltip key={item} title={item} placement='right' overlayClassName='sideNavPopUp'>
                        <motion.li
                            data-test-id={item}
                            className={style.item}
                            onClick={() => {
                                setSelected(index);
                                handleRedirect(item);
                            }}
                            style={{
                                position: "relative",
                                width: "inherit",
                                height: "inherit",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                margin:0,
                                marginBottom:8
                            }}
                        >
                            {icons.find((icon) => icon.key === item)?.icon}
                        </motion.li>
                    </Tooltip>
                ))}
            </ul>
            <div className={style.bottomSection} style={{display: capabilities ? "none" : "flex"}}>
                <Popover
                    data-test-id="user"
                    visible={popUpState}
                    onVisibleChange={(status) => setPopUpState(status)}
                    overlayClassName='userPopUp'
                    title={popupTitle}
                    content={popupContent}
                    placement='bottomLeft'
                    trigger='click'
                >
                    {/* <div className={style.profile}> */}
                    {/* <img src={UserImage} alt="err"/> */}
                    <Tooltip key="userProfile" title="User Profile" placement='right' overlayClassName='sideNavPopUp'>
                    <UserImage height='20px' width='20px' style={{ cursor: 'pointer' }} />
                    </Tooltip>
                    {/* </div> */}
                </Popover>
                <Tooltip key="help" title="Need Help?" placement='right' overlayClassName='sideNavPopUp'>
                <Help data-test-id="help" height='20px' width='20px' />
                </Tooltip>
            </div>
            {guideVisible && <Onboarding></Onboarding>}
        </div>
    )
}


export default SidenavBar;
